module.exports = __webpack_public_path__ + "img/nodeType2.22fe055e.svg";